import { createSelector } from 'reselect'
import { isEmpty, groupBy } from 'lodash-es'
import moment from 'moment'

const getTime = (state) => state?.site?.siteData?.timeFormat ?? ''

const getTimeFormat = createSelector(getTime, (data) => data)

const formatComments = (comments, format) => {
  if (isEmpty(comments)) {
    return []
  }

  return comments.toArray().map((comment) => {
    const date = comment.creation_date_ansi || comment.entry_date_ansi

    return { ...comment, ...{ dateFormatted: moment(date).format(format) } }
  })
}

export default ({ getFeatureRoot }) => {
  const getChatComments = (state) => getFeatureRoot(state).chat.comments
  const getQuestionComments = (state) =>
    getFeatureRoot(state).questions.comments

  const getQuestions = createSelector(
    [getQuestionComments, getTimeFormat],
    (questions, format) => formatComments(questions, format)
  )

  const getChatMessages = createSelector(
    [getChatComments, getTimeFormat],
    (messages, format) => formatComments(messages, format)
  )

  const getQuestionGroupedByStatus = createSelector(
    getQuestionComments,
    (questions) => {
      const groupedComments = groupBy(questions.toArray(), 'comment_status')
      return groupedComments
    }
  )

  return {
    getQuestions,
    getChatMessages,
    getQuestionGroupedByStatus,
  }
}
